import { Component, Input, ElementRef, ViewChild, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-before-after-comparison',
  templateUrl: './before-after-comparison.component.html',
  styleUrls: ['./before-after-comparison.component.scss']
})
export class BeforeAfterComparisonComponent implements AfterViewInit {
  @Input() beforeImageUrl: string;
  @Input() afterImageUrl: string;
  @ViewChild('beforeImage') beforeImage: ElementRef;
  @ViewChild('afterImage') afterImage: ElementRef;
  @ViewChild('slider') slider: ElementRef;

  clicked: boolean = false;

  ngAfterViewInit(): void {
    this.onResize();
  }

  onResize(): void {
    if (this.afterImage && this.beforeImage) {
      this.beforeImage.nativeElement.children[0].style.width = this.afterImage.nativeElement.offsetWidth + 'px';
      this.beforeImage.nativeElement.style.width = null;
      this.slider.nativeElement.style.left = null;
    }
  }

  // https://www.w3schools.com/howto/howto_js_image_comparison.asp
  slideReady(event: MouseEvent): void {
    event.preventDefault();
    this.clicked = true;
  }

  slideFinish(event: MouseEvent): void {
    this.clicked = false;
  }

  slideMove(event: MouseEvent): void {
    if (!this.clicked)
      return;

    let position = this.getCursorPosition(event);

    if (position < 0)
      position = 0;
    if (position > this.afterImage.nativeElement.offsetWidth)
      position = this.afterImage.nativeElement.offsetWidth;

    this.slide(position);
  }

  getCursorPosition(event: any): number {
    let a = 0;
    let x = 0;

    a = this.afterImage.nativeElement.getBoundingClientRect();
    x = (event.touches ? event.touches[0].clientX : event.clientX) - a['left'];
    x = x - window.pageXOffset;

    return x;
  }

  slide(position: number): void {
    this.beforeImage.nativeElement.style.width = position + 'px';
    this.slider.nativeElement.style.left = position + 'px';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/before-after-comparison/before-after-comparison.component.ts